<template>
  <div id="app">
    <router-view v-if="isRoutrtAlive"/>
  </div>
</template>
<script>
import { getLodop } from '@/libs/LodopFuncs.js';
export default {
	name: 'App',
	provide() {
		return {
			reload: this.reload
		}
	},
	data() {
		return {
			isRoutrtAlive: true
		}
	},
	mounted() {
		// todo 绑定lodop注册码
		if (document.readyState === 'complete') {
			let LODOP = getLodop();
			LODOP.SET_LICENSES('', 'xxxlodop注册码', '', '');
		} else {
			document.onreadystatechange = () => {
				if (document.readyState === 'complete') {
					let LODOP = getLodop();
					LODOP.SET_LICENSES('', 'xxxlodop注册码', '', '');
				}
			};
		}
	},
	methods: {
		reload() {
			this.isRoutrtAlive = false
			this.$nextTick(()=>this.isRoutrtAlive=true)
		}
	}
}
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
